import { SVGProps } from 'react';

export const OpenClockIcon = (props: SVGProps<SVGSVGElement>) => {
	const color = props.color ?? '#BEBEBE';
	return (
		<svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M1 7C1 10.3137 3.68629 13 7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C5.46329 1 4.06151 1.57771 3 2.52779'
				stroke='black'
				strokeLinecap='round'
			/>
			<path d='M7 4V7L9 9' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
			<path d='M2.5 1.5V3H4' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
		</svg>
	);
};
